import React from 'react';
import { Space, Tooltip } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { useAtom, useAtomValue } from 'jotai';
import { checkFeature } from '@utils/platform/features/checkFeature';
import { realTimeModeOnTrendsSelector } from '@store/common/selectors';
import { isMetricTabActiveAtom } from '@src/components/metrics-panel-hz/atoms';
import { modeAtom, TABLE_MODES } from '@src/components/dimension-panel-hz/atoms';
import { initCompare } from '@src/store/trends/base/actions';
import { COMPARE_TYPES } from '@src/store/trends/base/reducer';
import { StyledButton } from './styled';
import AdvCompareIcon from '@src/icons/common/adv-compare.svg';
import AdvFilterIcon from '@src/icons/common/adv-filter.svg';
import Icon from '@ant-design/icons/lib/components/Icon';

function AdvancedOptions() {
  const isLiveMode: boolean = useSelector(realTimeModeOnTrendsSelector);
  const [mode, setMode] = useAtom(modeAtom);
  const isMetricTabActive = useAtomValue(isMetricTabActiveAtom);
  const dispatch = useDispatch();

  // disable interactions when a drawer is active
  const hasActiveDrawer = mode !== TABLE_MODES.drilldown;

  const handleFilterBuilderToggle = (value) => {
    const newMode = value ? TABLE_MODES.filter : TABLE_MODES.drilldown;
    setMode(newMode);
  };

  const handleCompareBuilderToggle = (value) => {
    const newMode = value ? TABLE_MODES.compare : TABLE_MODES.drilldown;
    setMode(newMode);
    dispatch(initCompare(COMPARE_TYPES.trends));
  };

  return (
    <Space>
      <Tooltip title="Advanced Filter">
        <StyledButton
          onClick={handleFilterBuilderToggle}
          disabled={hasActiveDrawer}
          icon={<Icon style={{ fontSize: 16 }} component={AdvFilterIcon} />}
        />
      </Tooltip>
      <Tooltip title="Advanced Compare">
        <StyledButton
          onClick={handleCompareBuilderToggle}
          disabled={
            hasActiveDrawer ||
            isLiveMode ||
            !isMetricTabActive ||
            !checkFeature('trends.base.compare', true)
          }
          icon={<Icon style={{ fontSize: 16 }} component={AdvCompareIcon} />}
        />
      </Tooltip>
    </Space>
  );
}

export default AdvancedOptions;
